import { debounce } from 'lodash';
import React, { FC, useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { format } from 'date-fns';
import dayjs from 'dayjs';

export type DurationFilter = {
	start?: string | null;
	end?: string | null;
};

type FormValues = {
	duration: [Date | null, Date | null] | Date;
};
const parseDate = (val: string | Date | null | undefined): Date | null => {
	if (!val) return null;
	const d = dayjs(val);
	return d.isValid() ? d.toDate() : null;
};
export const useDurationFilter = (start?: Date | string | null, end?: Date | string | null) => {
	const [transformDuration, setTransformDuration] = useState<DurationFilter>({
		start: start ? dayjs(start).format('YYYY-MM-DD') : null,
		end: end ? dayjs(end).format('YYYY-MM-DD') : null,
	});

	const name = 'duration' as const;

	const { control, watch } = useForm<FormValues>({
		defaultValues: { duration: [parseDate(start), parseDate(end)] },
	});

	const currentDuration: any = watch(name);

	const debouncedUpdate = useCallback(
		debounce((currentDuration: any) => {
			if (
				currentDuration &&
				Array.isArray(currentDuration) &&
				currentDuration.length > 1 &&
				currentDuration[0] instanceof Date &&
				!isNaN(currentDuration[0].getTime())
			) {
				setTransformDuration({
					start: dayjs(currentDuration[0]).format('YYYY-MM-DD'),
					end:
						currentDuration[1] && currentDuration[1] instanceof Date && !isNaN(currentDuration[1].getTime())
							? dayjs(currentDuration[1]).format('YYYY-MM-DD')
							: null,
				});
			} else {
				setTransformDuration({
					start: null,
					end: null,
				});
			}
		}, 300),
		[]
	);

	useEffect(() => {
		debouncedUpdate(currentDuration);
	}, [currentDuration, debouncedUpdate]);

	return {
		name,
		control,
		currentDuration,
		transformDuration,
	};
};
